import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { gridData } from './documentation-grid-data';
import { gridOptions } from '../documentation-grid-options';

@Component({
  selector: 'aux-buttons',
  templateUrl: './buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class ButtonsComponent {
  documentationData = gridData;

  documentationOptions = gridOptions;

  buttons: {
    variant: 'success' | 'primary' | 'negative' | 'secondary' | 'custom';
    variantName: string;
    icon: string;
    classList?: string;
    description?: string;
  }[] = [
    {
      variant: 'primary',
      variantName: 'Primary',
      icon: 'download',
    },
    {
      variant: 'secondary',
      variantName: 'Secondary',
      icon: 'file-export',
    },
    {
      variant: 'negative',
      variantName: 'Negative',
      icon: 'x',
    },
    {
      variant: 'success',
      variantName: 'Success',
      icon: 'check',
    },
    {
      variant: 'custom',
      variantName: 'Custom',
      icon: 'lock',
      classList: 'btn--white btn',
      description: "Is used if other variants don't suit. Doesn't use any button classes.",
    },
  ];

  autoSize() {
    this.documentationOptions.api?.sizeColumnsToFit();
  }

  getClassListString(classList = '') {
    return classList ? ` classList="${classList}"` : '';
  }
}
